import { EquipmentTypeForTranslations } from './equipmentTypeTranslations';
import { EquipmentType } from './models';

export function translateForLookup(type: EquipmentType | EquipmentTypeForTranslations): string {
  return type?.toLowerCase()?.replace(/[ _-]/g, '');
}

export function translateMapForLookup<T extends keyof any>(map: Record<EquipmentType, T> | Record<T, T>): Record<string, T> {
  return Object.assign(
    {},
    ...Object.keys(map).map((equipmentType: EquipmentType) => ({
      [translateForLookup(equipmentType)]: map[equipmentType],
    })),
  );
}

export function translateMapForLookupTranslations<T>(map: Record<EquipmentType, T>): Record<string, T> {
  return Object.assign(
    {},
    ...Object.keys(map).map((equipmentType: EquipmentTypeForTranslations) => ({
      [translateForLookup(equipmentType)]: map[equipmentType],
    })),
  );
}
